import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ mode = "success" }) {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(mode === "success" ? "checking" : "cancelled");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (mode !== "success") return;
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setInfo(data);
        if (data.payment_status === "paid") setStatus("paid");
        else if (data.status === "expired" || data.status === "complete") setStatus("paid");
        else if (++attempts >= 8) setStatus("timeout");
        else setTimeout(poll, 2000);
      } catch {
        if (++attempts >= 8) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [params, mode]);

  return (
    <div className="container-deg py-32 max-w-xl text-center" data-testid="payment-result-page">
      {status === "checking" && (
        <div className="space-y-4">
          <Loader2 className="mx-auto animate-spin text-accent" size={36} strokeWidth={1.5} />
          <h1 className="font-serif text-3xl">Verifying payment…</h1>
        </div>
      )}
      {status === "paid" && (
        <div className="space-y-4">
          <CheckCircle2 className="mx-auto text-accent" size={48} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl">Booking confirmed</h1>
          <p className="text-ink-soft">Tight lines and see you at the lake.</p>
          {info?.amount && <p className="text-sm text-secondary">Charged €{info.amount} {info.currency?.toUpperCase()}</p>}
          <Link to="/booking" className="btn-primary inline-flex mt-4" data-testid="result-back-booking">Back to booking</Link>
        </div>
      )}
      {status === "cancelled" && (
        <div className="space-y-4">
          <XCircle className="mx-auto text-destructive" size={48} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl">Payment cancelled</h1>
          <p className="text-ink-soft">No charge was made. You can try again any time.</p>
          <Link to="/booking" className="btn-ghost inline-flex mt-4" data-testid="result-retry-booking">Try again</Link>
        </div>
      )}
      {(status === "error" || status === "timeout") && (
        <div className="space-y-4">
          <XCircle className="mx-auto text-destructive" size={48} strokeWidth={1.5} />
          <h1 className="font-serif text-4xl">Something went wrong</h1>
          <p className="text-ink-soft">We could not verify your payment automatically. Please contact us if you were charged.</p>
          <Link to="/" className="btn-ghost inline-flex mt-4">Back to home</Link>
        </div>
      )}
    </div>
  );
}
